export default __webpack_public_path__ + "static/media/logo@2x.2b11bd8e.png";